
import { EnvironmentEmailDashboard } from "./email-settings/EnvironmentEmailDashboard";
import { EmailDashboard } from "./email-settings/EmailDashboard";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useIsMobile } from "@/hooks/use-mobile";

const EmailSettings = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`container ${isMobile ? "px-2" : "px-0 sm:px-4"} py-6 max-w-full`}>
      <Tabs defaultValue="dashboard" className="w-full">
        <TabsList className={`${isMobile ? "w-full grid grid-cols-2" : ""} mb-6`}>
          <TabsTrigger 
            value="dashboard" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Email Dashboard
          </TabsTrigger>
          <TabsTrigger 
            value="environment" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Environment Config
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="dashboard">
          <EmailDashboard />
        </TabsContent>
        
        <TabsContent value="environment">
          <EnvironmentEmailDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EmailSettings;
